<div
  class="media-slot"
  [class.media-slot--cover]="fit === 'cover'"
  [class.media-slot--contain]="fit === 'contain'"
  [class.media-slot--rounded]="rounded">
  <!-- Cover (opaque banners): gray skeleton. Contain (PNG tiles): white — gray shows through alpha. -->
  <span
    class="media-slot__shimmer"
    [class.zt-skeleton]="fit === 'cover'"
    aria-hidden="true"></span>
  <ng-content></ng-content>
</div>
